export default __webpack_public_path__ + "static/media/discord.afdf09c9.svg";